import { render, staticRenderFns } from "./user-contact-certification.vue?vue&type=template&id=95547eee&"
import script from "./user-contact-certification.vue?vue&type=script&lang=js&"
export * from "./user-contact-certification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports